import type * as Type from "../type";

type Props = {
	optionPmsColorListServerData: Type.ServerData.OptionPmsColorListServerData | undefined;
};
type Result = {
	optionPmsColorListQueryData: Type.QueryData.OptionPmsColorListQueryData | undefined;
};

export const useOptionPmsColorListConverter = ({ optionPmsColorListServerData }: Props): Result => {
	if (!optionPmsColorListServerData) return { optionPmsColorListQueryData: undefined };

	return {
		optionPmsColorListQueryData: {
			optionPmsColorList: {
				id: optionPmsColorListServerData.optionPmsColorList.id,
				hotelID: optionPmsColorListServerData.optionPmsColorList.hotelID,
				optionColors: optionPmsColorListServerData.optionPmsColorList.optionColors,
			},
		},
	};
};
